// custom component
// service component
import Initialize from '@/usecases/ship/init'
import TokenVerify from '@/usecases/ship/auth/verify'
import MemberInitialize from '@/usecases/ship/member/init'
import MemberDashBoardFetch from '@/usecases/ship/member/dashboard/fetch'
import MemberTopFetch from '@/usecases/ship/member/top/fetch'
import MemberDailyReportFetch from '@/usecases/ship/member/daily/fetch'
import MemberLogBookFetch from '@/usecases/ship/member/logbook/fetch'
import MemberLogBookDetailFetch from '@/usecases/ship/member/logbookdetail/fetch'
import MemberSpareFetch from '@/usecases/ship/member/spare/fetch'
// import MemberLaborAttendanceAllFetch from "@/usecases/ship/member/laborAttendance/all";
import LaborRecordbook from '@/usecases/ship/member/labor/recordbook'
import LaborTimelineDaily from '@/usecases/ship/member/labor/timelineDaily'
//import ShipAuthSignUpShow from '@/usecases/ship/auth/signup/show'
//import ShipInitialize from '@/usecases/ship/init'
import ChatRoomFetch from '@/usecases/overall/chatRoom/fetch'
import FolderFetch from '@/usecases/overall/folder/fetch'
import FolderFetchByShare from '@/usecases/overall/folder/fetchByShare'
import LaborSailor from '@/usecases/ship/member/labor/sailor'
import LaborAttendAll from '@/usecases/ship/member/labor/attendAll'
import Ordering from '@/models/Ordering'

// models component
// import App from "@/models/App";

const today = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = ('00' + (date.getMonth() + 1)).slice(-2)
    const day = ('00' + date.getDate()).slice(-2)
    const output = `${year}-${month}-${day}`
    return output
}

const RouterShip = [
    {
        path: '/',
        component: () => import('@/components/ship/templates/globals/Index'),
        meta: { shipRequiresAuth: false },
        beforeEnter: (to, from, next) => {
            if (from.path == '/' && !from.name) {
                console.log(
                    'MRITIME7 SHIP 系列のURLを新しく開いた時（初回）だけの処理'
                )
                Initialize.of().then(() => {
                    if (
                        to.matched.some(
                            (record) => record.meta.shipRequiresAuth
                        )
                    ) {
                        TokenVerify.of()
                            .then((shipId) => {
                                if (shipId && to.name !== 'LaborAttendAll') {
                                    next({
                                        name: 'LaborAttendAll',
                                        params: { shipId: shipId },
                                    })
                                } else {
                                    next()
                                }
                            })
                            .catch(() => {
                                next('/signin')
                            })
                    } else {
                        next()
                    }
                })
            } else {
                if (to.matched.some((record) => record.meta.shipRequiresAuth)) {
                    TokenVerify.of()
                        .then((shipId) => {
                            if (shipId && to.name !== 'LaborAttendAll') {
                                next({
                                    name: 'LaborAttendAll',
                                    params: { shipId: shipId },
                                })
                            } else {
                                next()
                            }
                        })
                        .catch(() => {
                            next('/signin')
                        })
                } else {
                    next()
                }
            }
        },
        children: [
            {
                path: 'signin',
                name: 'ShipSignIn',
                component: () => import('@/components/ship/pages/auths/SignIn'),
                meta: { shipRequiresAuth: false },
                beforeEnter: (to, from, next) => {
                    console.log('MARITME SHIP サインイン')
                    next()
                },
            },
            {
                path: 'signup',
                name: 'ShipSignUp',
                component: () => import('@/components/ship/pages/auths/SignIn'),
                meta: { shipRequiresAuth: false },
                beforeEnter: (to, from, next) => {
                    console.log('MARITME SHIP サインアップ')
                    next()
                },
            },
            {
                path: '',
                // name: "ShipMain",
                component: () =>
                    import('@/components/ship/templates/members/Index'),
                meta: { shipRequiresAuth: true },
                beforeEnter: (to, from, next) => {
                    console.log('MRITIME SHIP MEMBER INDEX')
                    MemberInitialize.of()
                        .then(() => {
                            next()
                        })
                        .catch(() => {
                            next('/signin')
                        })
                },
                children: [
                    // ホーム
                    {
                        path: '',
                        name: 'HomeDashboard',
                        component: () =>
                            import('@/components/ship/pages/members/DashBoard'),
                        meta: { shipRequiresAuth: true },
                        beforeEnter: (to, from, next) => {
                            console.log('MRITIME SHIP MEMBER DASHBOARD ')
                            MemberDashBoardFetch.of()
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/signin')
                                })
                        },
                    },
                    // チャット
                    {
                        path: 'chat',
                        name: 'GlobalChat',
                        component: () =>
                            import('@/components/global/pages/Chat'),
                        meta: { shipRequiresAuth: true },
                        beforeEnter: (to, from, next) => {
                            console.log('MRITIME SHIP チャット')
                            // 現在はテスト環境でのみAppSyncを使用したいため変更
                            // if (process.env.VUE_APP_ENV_MODE === 'local') {
                            // if (process.env.VUE_APP_ENV_MODE !== 'test') {
                            ChatRoomFetch.of()
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/signin')
                                })
                            // } else {
                            //     next()
                            // }
                        },
                    },
                    // フォルダ
                    {
                        path: 'folder',
                        component: () =>
                            import('@/components/global/pages/Folder'),
                        name: 'GlobalFolder',
                        meta: { shipRequiresAuth: true },
                        beforeEnter: (to, from, next) => {
                            FolderFetch.of()
                                .then(() => {
                                    console.log(
                                        'MRITIME SHIP フォルダ マイドライブ'
                                    )
                                    next()
                                })
                                .catch(() => {
                                    next('/signin')
                                })
                            FolderFetchByShare.of()
                                .then(() => {
                                    console.log(
                                        'MRITIME SHIP フォルダ 共有アイテム'
                                    )
                                    next()
                                })
                                .catch(() => {
                                    next('/signin')
                                })
                        },
                    },
                    // 船舶管理 : 日報集計(TOP)
                    {
                        path: ':shipId(\\d+)',
                        name: 'ShipTop',
                        component: () =>
                            import('@/components/ship/pages/members/ships/Top'),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶ダッシュボード',
                                to.params.shipId
                            )
                            MemberTopFetch.of(to.params.shipId)
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/signin')
                                })
                        },
                    },
                    // 船舶管理 : 日報
                    {
                        path: ':shipId(\\d+)/noon',
                        name: 'ShipDailyReport',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/DailyReport'
                            ),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶 日報管理',
                                to.params.shipId
                            )
                            MemberDailyReportFetch.of(to.params.shipId, {})
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 船舶管理 : 航海日誌
                    {
                        path: ':shipId(\\d+)/ablog',
                        name: 'ShipLogBook',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/AbLog'
                            ),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶 航海日誌',
                                to.params.shipId
                            )
                            MemberLogBookFetch.of(to.params.shipId, {})
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 船舶管理 : 航海日誌・詳細
                    {
                        path: ':shipId(\\d+)/ablog/:type(deck|engine)/:logBookId(\\d+)',
                        name: 'ShipLogBookDetail',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/LogBookDetail'
                            ),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶 航海日誌 詳細',
                                to.params.shipId,
                                to.params.type,
                                to.params.logBookId
                            )
                            MemberLogBookDetailFetch.of(
                                to.params.shipId,
                                to.params.logBookId,
                                {}
                            )
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 保守管理 WIP
                    {
                        path: ':shipId(\\d+)/mainte',
                        name: 'ShipMaintenance',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Maintenance'
                            ),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶 保守管理',
                                to.params.shipId
                            )
                            next()
                        },
                    },
                    // 船舶管理: 予備品管理
                    {
                        path: ':shipId(\\d+)/spares',
                        name: 'ShipSpares',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Spares'
                            ),
                        meta: { shipRequiresAuth: true, shipChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log(
                                'MRITIME SHIP 管理船舶 予備品管理',
                                to.params.shipId
                            )
                            MemberSpareFetch.of(to.params.shipId, {})
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: 一括打刻パネル
                    {
                        path: ':shipId(\\d+)/labor/attend',
                        name: 'LaborAttendAll',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/AttendAll'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log('LaborAttendAll ')
                            LaborAttendAll.of(to.params.shipId, today())
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                        props: true,
                    },
                    // 労務管理: 閉鎖案内ページ
                    {
                        path: '/labor/closed',
                        name: 'LaborClosed',
                        component: () =>
                            import('@/components/ship/pages/members/LaborClosed'),
                        meta: { shipRequiresAuth: true },
                        beforeEnter: (to, from, next) => {
                            console.log('MRITIME SHIP MEMBER LABOR CLOSED')
                            next();
                        },
                    },
                    // 労務管理: 船員一覧
                    {
                        path: ':shipId(\\d+)/labor/sailor',
                        name: 'LaborSailorList',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/SailorList'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log('LaborSailorList ')
                            LaborSailor.of(to.params.shipId)
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: 日別
                    {
                        path: ':shipId(\\d+)/labor/timeline',
                        name: 'LaborDailyTimeline',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/DailyTimeline'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            LaborTimelineDaily.of(to.params.shipId, today())
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: 船員別
                    {
                        path: ':shipId(\\d+)/labor/record',
                        name: 'LaborRecordBook',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/RecordBook'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            LaborRecordbook.of(to.params.shipId)
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: 船員別 NEW
                    {
                        path: ':shipId(\\d+)/labor/record/new',
                        name: 'LaborRecordBookNew',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/RecordBookNew'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            LaborRecordbook.of(to.params.shipId)
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: 打刻ログ
                    {
                        path: ':shipId(\\d+)/labor/stamp',
                        name: 'LaborStampLog',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/StampLog'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                        beforeEnter: (to, from, next) => {
                            console.log('LaborStampLog ')
                            LaborSailor.of(to.params.shipId, true)
                                .then(() => {
                                    next()
                                })
                                .catch(() => {
                                    next('/')
                                })
                        },
                    },
                    // 労務管理: ダッシュボード(船全て)
                    {
                        path: 'all/labor/dashboard',
                        name: 'LaborDashboardAll',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/DashBoardAll'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                    },
                    // 労務管理: ダッシュボード(各船ごと)
                    {
                        path: ':shipId(\\d+)/labor/dashboard',
                        name: 'LaborDashboard',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/DashBoard'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                    },
                    // 労務管理: マスター設定
                    {
                        path: ':shipId(\\d+)/labor/setting',
                        name: 'LaborMasterSetting',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Labor/MasterSetting'
                            ),
                        meta: { shipRequiresAuth: true, laborChild: true },
                    },
                    // 動静管理: 位置情報
                    {
                        path: 'traffic/map',
                        name: 'TrafficMap',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Traffic/Map.vue'
                            ),
                        meta: { shipRequiresAuth: true, trafficChild: true },
                    },
                    // 動静管理: スケジュール
                    {
                        path: 'traffic/schedule',
                        name: 'TrafficSchedule',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Traffic/Schedule.vue'
                            ),
                        meta: { shipRequiresAuth: true, trafficChild: true },
                    },
                    // 動静管理: 航海履歴
                    {
                        path: 'traffic/record',
                        name: 'TrafficRecord',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Traffic/Record.vue'
                            ),
                        meta: { shipRequiresAuth: true, trafficChild: true },
                    },
                    // 動静管理: アカウント設定
                    {
                        path: 'traffic/account',
                        name: 'TrafficAccount',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Traffic/Account.vue'
                            ),
                        meta: { shipRequiresAuth: true, trafficChild: true },
                    },
                    // 動静管理: マップ(気象情報有り)
                    {
                        path: 'traffic/map/windy',
                        name: 'TrafficMapWindy',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Traffic/MapWindy.vue'
                            ),
                        meta: { shipRequiresAuth: true, trafficChild: true },
                    },
                    // 受発注管理: 発注側 - 在庫一覧
                    {
                        path: 'ordering/orderer/list',
                        name: 'OrderingOrdererList',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Orderer/OrderList.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        next()
                                        return
                                    case 'RECEIVER':
                                        break
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 発注側 - 進捗状況
                    {
                        path: 'ordering/orderer/progress',
                        name: 'OrderingOrdererProgress',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Orderer/OrderProgress.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        next()
                                        return
                                    case 'RECEIVER':
                                        break
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 発注側 - アカウント管理
                    {
                        path: 'ordering/orderer/account',
                        name: 'OrderingOrdererAccount',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Orderer/Account.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        next()
                                        return
                                    case 'RECEIVER':
                                        break
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 発注側 - 送信先管理
                    {
                        path: 'ordering/orderer/sending',
                        name: 'OrderingOrdererSending',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Orderer/Sending.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        next()
                                        return
                                    case 'RECEIVER':
                                        break
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 受注側 - 見積一覧
                    {
                        path: 'ordering/receiver/estimate',
                        name: 'OrderingReceiverEstimate',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Receiver/Estimate.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        break
                                    case 'RECEIVER':
                                        next()
                                        return
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 受注側 - 進捗状況
                    {
                        path: 'ordering/receiver/progress',
                        name: 'OrderingReceiverProgress',
                        component: () =>
                            import(
                                '@/components/ship/pages/members/ships/Ordering/Receiver/Progress.vue'
                            ),
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            // 受発注アカウント権限に応じてページへのアクセスを制限
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        break
                                    case 'RECEIVER':
                                        next()
                                        return
                                }
                            }
                            next('/')
                        },
                    },
                    // 受発注管理: 注文ドキュメントプレビュー
                    {
                        path: 'ordering/orderer/order/document',
                        component: () =>
                            import('@/components/ship/pages/members/ships/Ordering/Orderer/OrderDocumentPdfViewer'),
                        name: 'OrderDocumentPdfViewer',
                        meta: { shipRequiresAuth: true, ordererChild: true },
                        beforeEnter: (to, from, next) => {
                            if (Ordering.one()?.hasAccount) {
                                switch (Ordering.one()?.accountType) {
                                    case 'OWNER':
                                    case 'MANAGER':
                                    case 'ORDERER':
                                        next()
                                        return
                                    default:
                                        break
                                }
                            }
                            next('/')
                        },
                    },
                ],
            },
        ],
    },
]
export default RouterShip
